export default __webpack_public_path__ + "static/media/sofia4.54410456.jpg";